import { useTranslation } from 'react-i18next';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from '@/shared/components/ui';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary?: () => void;
}

export function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  const { t } = useTranslation();

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 dark:bg-slate-900">
      <div className="mx-auto max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-error-100 dark:bg-error-900">
          <AlertTriangle className="h-8 w-8 text-error-600 dark:text-error-400" />
        </div>

        <h1 className="mb-2 text-2xl font-bold text-slate-900 dark:text-slate-100">
          {t('errors.serverError')}
        </h1>

        <p className="mb-6 text-slate-600 dark:text-slate-400">
          {t('errors.serverErrorDesc')}
        </p>

        {process.env.NODE_ENV === 'development' && (
          <div className="mb-6 rounded-lg bg-slate-100 p-4 text-start dark:bg-slate-800">
            <p className="mb-2 text-sm font-medium text-slate-700 dark:text-slate-300">
              Error Details:
            </p>
            <pre className="overflow-auto text-xs text-error-600 dark:text-error-400">
              {error.message}
            </pre>
          </div>
        )}

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          {resetErrorBoundary && (
            <Button
              variant="primary"
              onClick={resetErrorBoundary}
              leftIcon={<RefreshCw className="h-4 w-4" />}
            >
              {t('errors.tryAgain')}
            </Button>
          )}
          <Button
            variant="outline"
            onClick={handleGoHome}
            leftIcon={<Home className="h-4 w-4" />}
          >
            {t('errors.goHome')}
          </Button>
        </div>
      </div>
    </div>
  );
}
